/* <rr-zoom> — visor a pantalla completa para la galería del PDP.
   Usa <dialog> nativo (Escape y foco los gestiona el navegador).
   Un toque amplía y el puntero desplaza la zona ampliada mediante
   transform-origin: sin cálculos de arrastre y sin dependencias.
   La imagen grande solo se descarga al abrir. */
(() => {
  if (customElements.get('rr-zoom')) return;

  class RRZoom extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.img = this.querySelector('[data-rr-zoom-img]');
      this.count = this.querySelector('[data-rr-zoom-count]');
      if (!this.dialog || !this.img) return;

      this.all = [...document.querySelectorAll('[data-rr-zoom-src]')];
      this.tiles = this.all;
      this.all.forEach((t) => t.addEventListener('click', () => this.open(t)));

      // Del 15 al 19 oct 2026 (R-03) el resto de fotos iba en una columna bajo el
      // botón solo con CSS y salía del tabulador (WCAG 2.4.3). Desde el carrusel
      // del móvil (19 oct) el orden en pantalla es el del HTML: todas tabulables.

      this.querySelector('[data-rr-zoom-close]').addEventListener('click', () => this.dialog.close());
      this.querySelectorAll('[data-rr-zoom-step]').forEach((b) =>
        b.addEventListener('click', () => this.show(this.index + Number(b.dataset.rrZoomStep)))
      );

      this.img.addEventListener('click', () => this.toggle());
      this.img.addEventListener('pointermove', (e) => this.track(e));
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.zoom(false));
      document.addEventListener('keydown', (e) => {
        if (!this.dialog.open) return;
        if (e.key === 'ArrowRight') this.show(this.index + 1);
        if (e.key === 'ArrowLeft') this.show(this.index - 1);
      });
    }

    open(tile) {
      // solo recorre lo que se ve: la galeria puede tener grupos ocultos por variante
      this.tiles = this.all.filter((t) => !t.closest('[hidden]'));
      this.show(Math.max(0, this.tiles.indexOf(tile)));
      this.dialog.showModal();
    }

    show(i) {
      if (!this.tiles.length) return;
      this.index = (i + this.tiles.length) % this.tiles.length;
      const tile = this.tiles[this.index];
      this.img.src = tile.dataset.rrZoomSrc;
      this.img.alt = tile.dataset.rrZoomAlt || '';
      this.zoom(false);
      if (this.count) this.count.textContent = `${this.index + 1} / ${this.tiles.length}`;
    }

    toggle() {
      this.zoom(this.img.dataset.zoomed !== 'true');
    }

    zoom(on) {
      this.img.dataset.zoomed = on ? 'true' : 'false';
      if (!on) this.img.style.transformOrigin = '50% 50%';
    }

    track(e) {
      if (this.img.dataset.zoomed !== 'true') return;
      const r = this.img.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      this.img.style.transformOrigin = `${x}% ${y}%`;
    }
  }

  customElements.define('rr-zoom', RRZoom);
})();
